<template>
  <div class="kst-invoice-related">
    <kst-warning :items="formWarnings"/>
    <kst-failure list-mode :message="failureList"/>

    <template v-if="!failureList">
      <template v-if="!formWarnings">
        <Action :salesId="salesId"/>
        <Row :items="dataList" :isLoading="isLoading"/>
      </template>
    </template>
  </div>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import Info from "../InvoiceInfo.js";
import Model from "../InvoiceModel.js";
import Services from "../InvoiceServices.js";

import Action from "./InvoiceRelated_Action";
import Row from "./InvoiceRelated_Row";

export default {
  mixins: [AxiosMixin],
  components: {
    Action,
    Row
  },
  props: {
    salesId: Number,
    items: Array
  },
  data: () => ({
    Model: Model,
    dataList: [],
    isLoading: false,
    // initial error
    formWarnings: null,
    failureList: null
  }),
  created() {
    this.init();
  },
  methods: {
    init() {
      this.dataList = [];
      this.formWarnings = null;

      if (this.items) {
        this.dataList = this.items;
        this.updateList(this.dataList);
      }
      else if (this.salesId) {
        this.initLoad(this.salesId);
      }
      else {
        this.formWarnings = [Info.Message.Related_ParamIncomplete];
      }
    },
    initLoad(salesId) {
      this.failureList = null;
      this.isLoading = true;
      this.dataList = [];

      this.loadList(salesId);
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadList(salesId) {
      const options = { sales: salesId, withitems: 1 };
      const config = Services.getInvoiceList(options);
      this.runAxios(config, null, this.loadList_Success, this.loadList_Error);
    },
    loadList_Success(data) {
      this.dataList = data;
      this.updateList(this.dataList);
      this.initLoad_End();
    },
    loadList_Error(message) {
      this.failureList = message;
      this.initLoad_End();
    },

    updateList(dataList) {
      for (const data of dataList) {
        for (const item of data.Items) {
          Model.updateItemByPackaging(item);
        }
      }
    }
  }
}
</script>

<style scoped lang="css" src="./_layout.css"/>